import { Box, Button, Grid, Typography } from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import PeopleIcon from "@mui/icons-material/People";
import CampaignIcon from "@mui/icons-material/Campaign";
import StoreIcon from "@mui/icons-material/Store";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import LabelIcon from "@mui/icons-material/Label";
import ChairIcon from "@mui/icons-material/Chair";
import billig from "../../assets/icon/home/billing.png";
import dashboard from "../../assets/icon/home/dashboard.png";
import busi from "../../assets/icon/home/businessManagement.png";
import cust from "../../assets/icon/home/customerManagement.png";
import institure from "../../assets/icon/home/institute.png";
import franchise from "../../assets/icon/home/franchise.png";
import white from "../../assets/icon/home/whiteLabel.png";
import furniture from "../../assets/icon/home/furniture.png";
import consult from "../../assets/icon/home/consultant.png";
import { routePath } from "../../constants/routePath";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setBarName, setSideBarDrawer } from "../../app/store/reducer";

const HomeDashboard = () => {
  const NameData = {
    Home: 1,
    "Business Management": 1,
    "Customer Management": 1,
  };
  const dispatch = useDispatch();
  const analatics = useSelector((state) => state.reducer.analatics);
  const customerChategory = useSelector(
    (state) => state.reducer.customerChategory,
  );
  const bussinessMangementMenu = useSelector(
    (state) => state.reducer.bussinessMangementMenu,
  );
  const billerMenu = useSelector((state) => state.reducer.billerMenu);
  const institute = useSelector((state) => state.reducer.institute);
  const franchise = useSelector((state) => state.reducer.franchise);
  const consultant = useSelector((state) => state.reducer.consultant);
  const whitelabels = useSelector((state) => state.reducer.whitelabels);

  const urlHeaderMenu = useSelector((state) => state.reducer.urlHeaderMenu);
  const headerMenu = useSelector((state) => state.reducer.headerMenu);
  const titleHead1 = (ele) => {
    const indexRoute = headerMenu.findIndex(
      (it) => it.systemFuctionName === ele.systemFuctionName,
    );
    if (NameData[ele?.systemFuctionName]) {
      return ele?.systemFuctionName;
    }
    if (headerMenu[indexRoute]?.regionalFunctionName.includes("Counter Sale")) {
      return "Billing";
    }

    return headerMenu[indexRoute]?.regionalFunctionName;
  };
  const navigate = useNavigate();

  const menuItems = [
    { title: "Billing", icon: billig, path: routePath.COUNTERSELL },
    { title: "Dashboard & Reports", icon: dashboard },
    {
      title: "Business Management",
      icon: busi,
    },
    { title: "Customer Management", icon: cust },
    { title: "Post Institute Ads", icon: institure },
    { title: "Post Franchise Ads", icon: franchise },
    { title: "Post Consultant Ads", icon: consult },
    { title: "Post White Label Ads", icon: white },
    {
      title: "New Furniture & Equipments",
      icon: furniture,
    },
  ];
  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Box
        px={{ xs: 1, sm: 4 }}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
          height: "100%",
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px 15px",
              mt: "10px",
              borderRadius: "5px",
              color: "#01008B",
              textAlign: "left",
              marginBottom: "20px",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            <Typography
              variant="h6"
              fontSize={{
                xs: "12px",
                sm: "13px",
                md: "20px",
              }}
            >
              Home
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2} justifyContent="center" sx={{ mt: 3 }}>
          {urlHeaderMenu?.map((item, index) => {
            // if(urlHeaderMenu.length-1==  index){
            //   return null
            // }
            //console.log("Sidebar Item ===", item);

            const indexRouteRilg = headerMenu.findIndex(
              (it) => it.systemFuctionName === item.systemFuctionName,
            );

            const isRestricted =
              item.systemFuctionName === "Cash Sale Bill" ||
              item.systemFuctionName === "Dashboard";

            if (
              isRestricted &&
              !headerMenu[indexRouteRilg]?.systemFuctionName
            ) {
              return null; // skip rendering
            }

            const label =
              item?.label == "Billing" ? item.label : titleHead1(item);

            if (!label) return null;
            return (
              <Grid
                item
                key={index}
                xs={4} // 3 cards per row on mobile
                sm="auto" // auto width for larger screens
              >
                <Box
                  key={index}
                  sx={{
                    width: { xs: "100%", sm: 140 },
                    height: { xs: 120, sm: 140 },
                    height: { sm: 140, xs: 120 }, // fixed height
                    backgroundColor: "#010093",
                    borderRadius: "12px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between", // image at top, text at bottom evenly
                    // paddingY: 2,
                    justifyContent: "center",
                    color: "#fff",
                    cursor: "pointer",
                    transition: "0.3s",
                    textAlign: "center",
                    "&:hover": { boxShadow: "0px 8px 20px rgba(0,0,0,0.2)" },
                  }}
                  //   onClick={() => navigate(item.route)}
                  onClick={() => {
                    dispatch(setSideBarDrawer(true))
                    const tt = titleHead1(item);

                    let reducerArray = [];

                    if (tt === "Business Management") {
                      dispatch(setBarName("bussinessMangment"));
                      reducerArray = bussinessMangementMenu;
                    }

                    if (tt === "Customer Management") {
                      dispatch(setBarName("CustomerMangment"));
                      reducerArray = customerChategory;
                    }

                    if (item.systemFuctionName === "Dashboard") {
                      dispatch(setBarName("analatic"));
                      reducerArray = analatics;
                    }

                    if (tt === "Billing") {
                      dispatch(setBarName("billing"));
                      reducerArray = billerMenu;
                    }
                    if (item.systemFuctionName === "My Institute") {
                      dispatch(setBarName("institute"));
                      reducerArray = institute;
                    }
                    if (item.systemFuctionName === "My Franchise") {
                      dispatch(setBarName("franchise"));
                      reducerArray = franchise;
                    }
                    if (item.systemFuctionName === "Post Consultant Ads") {
                      dispatch(setBarName("consultant"));
                      reducerArray = consultant;
                    }
                    if (item.systemFuctionName === "White Lable") {
                      dispatch(setBarName("whitelabels"));
                      reducerArray = whitelabels;
                    }
                    if (!reducerArray?.length) return;

                    // 🔎 1️⃣ Try to find matching item
                    // 🔎 Try to find matching reducer item
                    if (!reducerArray?.length) return;

                    const allowedRoute = reducerArray.find((reducerItem) =>
                      headerMenu.some(
                        (headerItem) =>
                          headerItem.systemFuctionName ===
                          reducerItem.systemFuctionName,
                      ),
                    );

                    if (allowedRoute?.route) {
                      navigate(allowedRoute.route);
                    } else {
                      const fallback = reducerArray.find((it) => it?.route);
                      if (fallback) navigate(fallback.route);
                    }
                  }}
                >
                  <Box
                    component="img"
                    src={item.icon}
                    alt={item.title}
                    sx={{
                      width: { sm: 50, xs: 25 },
                      height: { sm: 50, xs: 25 },
                      objectFit: "contain",
                      mb: 1,
                    }}
                  />

                  <Typography
                    mt={1}
                    sx={{
                      fontSize: { xs: "12px", sm: "13px", md: "14px" },
                      height: { xs: 36, sm: 39, md: 42 }, // approximate height for 3 lines depending on font size
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                    }}
                    textAlign="center"
                    px={1}
                  >
                    {/* {item?.label == "Billing" ? item.label : titleHead1(item)} */}
                    {label}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </>
  );
};

export default HomeDashboard;
